module.exports = __webpack_public_path__ + "img/white-right-arrow.1fd68bed.svg";